import { render, staticRenderFns } from "./NewPayment.vue?vue&type=template&id=f4c64e34"
import script from "./NewPayment.vue?vue&type=script&lang=js"
export * from "./NewPayment.vue?vue&type=script&lang=js"
import style0 from "./NewPayment.vue?vue&type=style&index=0&id=f4c64e34&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports